// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"1d1a4fc5","92":"95996949","260":"6cc2a47d","317":"7ddb16e4","551":"1011dd22","765":"000ab270","773":"b3dba9f4","903":"443f5adb"}[chunkId] + ".chunk.js";
};